import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const SbuForm = ({ sbuId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [sbuName, setSbuName] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     // ✅ Fill form if initialData is provided (edit mode)
     useEffect(() => {
          if (initialData && initialData.sbu) {
               setSbuName(initialData.sbu);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!sbuName.trim()) {
               setError('SBU name is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               let url = '';
               let method = 'POST';
               let body = {};

               if (sbuId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateSbuById/${sbuId}`;
                    body = { sbu: sbuName };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createSbu`;
                    body = { sbu: sbuName };
               }

               const response = await fetch(url, {
                    method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(sbuId ? 'SBU updated successfully' : 'SBU created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/sbu');
               } else {
                    setError(data.message || `Failed to ${sbuId ? 'update' : 'create'} SBU`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };

     const handleCloseModal = () => {
          navigate('/sbu');
     };

     return (
          <form className="general-info-form" onSubmit={handleSubmit}>
               {/* <h2 className="section-title">{sbuId ? 'Edit SBU' : 'Add SBU'}</h2> */}
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="sbuName"
                              placeholder=" "
                              autoComplete="off"
                              value={sbuName}
                              onChange={(e) => setSbuName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="sbuName">SBU Name</label>
                    </div>
               </div>

               {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}

               <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                    <button
                         type="submit"
                         className="btn btn-primary"
                         disabled={loading}
                    >
                         {loading ? 'Saving...' : 'Save'}
                    </button>

                    <button
                         type="button"
                         className="btn btn-secondary"
                         onClick={handleCloseModal}
                         disabled={loading}
                    >
                         Cancel
                    </button>
               </div>
          </form>

     );
};

export default SbuForm;
